import { extendConfig } from "@cloudflare/realtimekit-react-ui";
import type { UIConfig } from "@cloudflare/realtimekit-react-ui";

type StageRootEntry = {
  children?: unknown[];
  [key: string]: unknown;
};

/** Fragmento de UIConfig: sem toast/som de "X acabou de entrar". */
export const PARTICIPANT_JOINED_NOTIFICATIONS_OFF = {
  config: {
    notifications: {
      participant_joined: false,
    },
    notification_sounds: {
      participant_joined: false,
    },
  },
} as const;

function stripNotificationsFromStage(config: UIConfig): UIConfig {
  const stage = config.root?.["rtk-stage"] as StageRootEntry | undefined;
  if (!stage || !Array.isArray(stage.children)) {
    return config;
  }

  const children = stage.children.filter((child) => {
    if (typeof child === "string") {
      return child !== "rtk-notifications";
    }
    if (Array.isArray(child) && typeof child[0] === "string") {
      return child[0] !== "rtk-notifications";
    }
    return true;
  });

  if (children.length === stage.children.length) {
    return config;
  }

  return {
    ...config,
    root: {
      ...config.root,
      "rtk-stage": {
        ...stage,
        children,
      },
    },
  };
}

/** Mescla preferências + remove `rtk-notifications` do palco (evita bip/toast mesmo após preset). */
export function buildMeetingUiConfig(base?: UIConfig): UIConfig {
  const merged = extendConfig(PARTICIPANT_JOINED_NOTIFICATIONS_OFF, base);
  return stripNotificationsFromStage(merged);
}

export function applyJoinNotificationsOff(meetingEl: HTMLRtkMeetingElement | null): void {
  if (!meetingEl) {
    return;
  }
  meetingEl.config = buildMeetingUiConfig(meetingEl.config);
}
